import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import PayrollBundle from 'modules/payroll_bundle/store/models/PayrollBundle'

class Payroll extends Collection<PayrollBundle> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      config: computed,
    })
  }

  get cacheKey(): string {
    return 'payroll'
  }

  model() {
    return PayrollBundle
  }

  get config(): PayrollBundle | null | undefined {
    return this.at(0)
  }
}

const singleton: Payroll = new Payroll()

export default singleton
